declare global {
  interface Array<T> {
    groupBy(fn: (item: T) => string | number): Map<string | number, T[]>;
    isEmpty(this: Array<T>): boolean;
  }
}

if (!Array.prototype.groupBy) {
  Array.prototype.groupBy = function <T, K extends string | number>(
    this: T[],
    fn: (item: T) => K,
  ): Map<K, T[]> {
    return this.reduce<Map<K, T[]>>((prev, curr) => {
      const groupKey = fn(curr);
      const group = prev.get(groupKey) || [];
      group.push(curr);
      prev.set(groupKey, group);
      return prev;
    }, new Map<K, T[]>());
  };
}

if (!Array.prototype.isEmpty) {
  Array.prototype.isEmpty = function <T, K extends string | number>(
    this: T[],
  ): boolean {
    return this.length === 0;
  };
}

export {};
